// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__zZ9tq","header":"Messages_header__26Tej"};